<template>
    <svg class="pie-chart" :width="width" :height="height" :viewBox="'0 0 '+width+' '+height">
        <g :transform="'translate('+margin.left+','+margin.top+')'">
            <g :transform="'translate('+(chartWidth/2)+','+(chartHeight/2)+')'">
                <g v-for="d in pie(data)" class="arc" :fill="color(d.data[dimensions.ordinal[0]])">
                    <title>{{d.data[dimensions.ordinal[0]]}}: {{d.data.sum}}</title>
                    <path :d="path(d)"></path>
                </g>
            </g>
        </g>
    </svg>
</template>
<script>
    import * as d3 from 'd3';
    import numeral from 'numeral';

    export default{
        data: function(){
            return {
                width: 825,
                height: 510,
                margin:{
                    left: 10,
                    top: 10,
                    right: 10,
                    bottom: 10
                }
            }
        },
        props:['data', 'dimensions'],
        computed:{
            chartWidth: function(){
                return this.width - this.margin.left - this.margin.right;
            },
            chartHeight: function(){
                return this.height - this.margin.top - this.margin.bottom;
            },
            radius: function(){
                return Math.min(this.chartWidth, this.chartHeight) / 2;
            },
            pie: function(){
                return d3.pie()
                    .sort(null)
                    .value(function(d) {return d.sum; });
            },
            path: function(){
                return d3.arc()
                    .outerRadius(this.radius - 10)
                    .innerRadius(0);
            },
            color: function(){
                return d3.scaleOrdinal(d3.schemeCategory10);
            },

        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Charts/Pie.vue